'use client';

import { useState } from 'react';

/** The adjacent category name labels the link. No unrelated replacement image
 * is shown if an upstream catalogue image is missing or fails to load.
 */
export function CategoryThumbnail({ src }: { src?: string }) {
  const [failedSrc, setFailedSrc] = useState<string>();
  if (!src || failedSrc === src) return null;
  return (
    // Catalogue images use several supplier hosts; keep the existing direct-image delivery.
    // eslint-disable-next-line @next/next/no-img-element
    <img src={src} alt="" width={96} height={80} loading="lazy" decoding="async"
      onError={() => setFailedSrc(src)}
      className="h-16 w-20 shrink-0 rounded-lg bg-white object-contain sm:h-20 sm:w-24" />
  );
}
